import * as a from 'actions/devicemanagement';

const initialState = {
	configMap: null,
};

function serialize(obj) {
	// deep deterministic serialize.
	// used to generate hash of nested config objects.

	if ((obj !== Object(obj))) {
		// obj is primitive
		// https://stackoverflow.com/questions/31538010/test-if-a-variable-is-a-primitive-rather-than-an-object
		return JSON.stringify(obj);
	} else {
		// obj is an object
		var keys = Object.keys(obj).sort();
		var res = "{";
		keys.forEach((key) => {
			res += JSON.stringify(key) + ":" + serialize(obj[key]) + ",";
		});
		res += "}";
		return res;		
	}
}

function generateColor(configMap) {
	var macs = Object.keys(configMap);
	var mac2hash = {};
	var hash2color = {};
	var mac2color = {};
	macs.forEach((mac) => {
		var hash = serialize(configMap[mac].currentConfig); // TODO : use md5 hash of serialized string instead of raw serialized string, to achieve limited length, better performace.
		mac2hash[mac] = hash;
		hash2color[hash] = null;
	});

	var hashs = Object.keys(hash2color);
	var numColors = hashs.length;
	hashs.forEach((hash, idx) => {
		var i = idx * 360 / numColors;
		var hue = i;
		var saturation = 90 + Math.random()*10;
		var lightness = 50 + Math.random()*10;
		hash2color[hash] = "hsl(" + hue + "," + saturation + "%," + lightness + "%)"
	});

	macs.forEach((mac) => {
		var hash = mac2hash[mac];
		var color = hash2color[hash];
		mac2color[mac] = color;
	})
	return mac2color;
}


export default (state = initialState, action) => {
	switch (action.type) {
		case a.RECEIVE_CONFIG: {
			var colors = generateColor(action.data);
			return Object.assign({}, state, {
				configMap: action.data,
				colors: colors,
			});
		}
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/devicemanagement.jsx